// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__CewwK","neutral":"Button_neutral__qAV56","primary":"Button_primary__g2RYb","secondary":"Button_secondary__5NMeq","special":"Button_special__wUnRd"};